import { initialStateOptions } from '@/utils/pagination-utils';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  searchText: null,
  onlyAtivos: false,
  listOptions: initialStateOptions('descricao'),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
